import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { colors, typography } from '../../styles/theme';

interface PackUpsellBannerProps {
  priceLabel: string;
  onPurchase: () => void;
}

export default function PackUpsellBanner({ priceLabel, onPurchase }: PackUpsellBannerProps) {
  return (
    <Pressable
      style={({ pressed }) => [
        styles.container,
        pressed && styles.pressed
      ]}
      onPress={onPurchase}
    >
      <View style={styles.content}>
        <Text style={styles.title}>Unlock this pack</Text>
        <Text style={styles.subtitle}>Play all templates in this bundle forever.</Text>
      </View>
      <View style={styles.pricePill}>
        <Text style={styles.priceText}>Get {priceLabel}</Text>
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: colors.primary,
    padding: 16,
    borderRadius: 12,
    marginBottom: 20,
    boxShadow: `0px 4px 8px ${colors.primary}1A`, // 1A is ~10% opacity in hex
    elevation: 4,
  },
  pressed: {
    transform: [{ scale: 0.98 }],
    opacity: 0.9,
  },
  content: {
    flex: 1,
    paddingRight: 12,
  },
  title: {
    ...typography.bodyBold,
    fontSize: 16,
    color: colors.text,
    marginBottom: 2,
  },
  subtitle: {
    ...typography.body,
    fontSize: 13,
    color: colors.textMuted,
    lineHeight: 18,
  },
  pricePill: {
    backgroundColor: colors.primary,
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 20,
  },
  priceText: {
    ...typography.bodyBold,
    color: '#fff',
    fontSize: 14,
  },
});
